var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('span',[_vm._v("年度損益: ")]),_c('ve-line',{attrs:{"data":_vm.chartData,"settings":_vm.chartSettings,"grid":_vm.grid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }